const normalizeErrorValue = value => {
  if (value == null) return null;

  if (typeof value === 'string') {
    const message = value.trim();
    return message || null;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    const messages = value.map(normalizeErrorValue).filter(Boolean);
    return messages.length ? messages.join('; ') : null;
  }

  if (typeof value === 'object') {
    const preferredFields = ['message', 'error', 'detail', 'details', 'title'];
    for (const field of preferredFields) {
      const message = normalizeErrorValue(value[field]);
      if (message) return message;
    }

    if (Object.keys(value).length === 0) return null;

    try {
      return JSON.stringify(value);
    } catch (error) {
      return null;
    }
  }

  return null;
};

export const getQuestionImportErrorMessage = error =>
  normalizeErrorValue(error?.response?.data) ||
  normalizeErrorValue(error) ||
  'Unable to import the survey question.';
